import { initFirebase } from '../firebase'
import { collection, getDocs, query, orderBy } from 'firebase/firestore'

const { db } = initFirebase()

export class FirebaseThumbService {
  async getAllThumbs() {
    const chatsRef = collection(db, 'chats')
    const q = query(chatsRef, orderBy('createdAt', 'desc'))
    const snapshot = await getDocs(q)
    const result = []
    snapshot.forEach(doc => {
      const data = doc.data()
      if (!data.messages || !Array.isArray(data.messages)) return
      const userId = data.userId
      data.messages.forEach((msg, index) => {
        if (!msg.feedbackThumb) return
        result.push({
          id: `${doc.id}-${index}`,
          chatId: doc.id,
          userId,
          content: msg.content,
          feedbackThumb: msg.feedbackThumb,
          role: msg.role,
          createdAt: msg.createdAt
        })
      })
    })
    result.sort((a, b) => {
      if (a.createdAt && b.createdAt) {
        const aTime = a.createdAt.seconds ? a.createdAt.seconds * 1000 : new Date(a.createdAt).getTime()
        const bTime = b.createdAt.seconds ? b.createdAt.seconds * 1000 : new Date(b.createdAt).getTime()
        return bTime - aTime
      }
      return 0
    })
    return result
  }

  async getThumbById(id) {
    const all = await this.getAllThumbs()
    return all.find(t => t.id === id) || null
  }
} 